import { gql } from '@apollo/client';

export const NAVIGATION = gql`
  fragment navigation on navigation_GlobalSet {
    navigation {
      ... on navigationBlock_Entry {
        id
        mainTitle
        navGroup {
          ... on navItem_Entry {
            id
            linkTitle
            ctaUrl {
              type
              url
            }
          }
        }
      }
    }
    openingHours {
      ... on openingHours_TableRow{
        day
        time
      }
    }
  }
`
